import axios from 'axios';

const api = '/api/product-types';

export const getAllProductTypes = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};

export const getById = id => {
  return axios.get(`${api}/${id}?cacheBuster=${new Date().getTime()}`);
};

export const create = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const update = (id, data) => {
  return axios.put(`${api}/${id}?cacheBuster=${new Date().getTime()}`, data);
};
